import React, { useEffect, useState, useMemo } from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import classNames from 'classnames';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { MLEndorsementFlowUtil, MLProductCodeUtil } from 'ml-portals-util-js';
import { useMLLandingPageContext } from 'gw-capability-gateway-quoteandbind-common-react';

import paWizardConfig from '../../../../../capabilities-react/gw-capability-policychange-pa-react/config/pa-policychange-wizard-config.json5';
import hoWizardConfig from '../../../../../capabilities-react/gw-capability-policychange-ho-react/config/ho-wizard-config.json5';
import pupWizardConfig from '../../../../../capabilities-react/gw-capability-policychange-pup-react/config/pup-wizard-config.json5';
import ampPaWizardConfig from '../../../../../capabilities-react/gw-capability-policychange-pa-react/config/pa-amp-wizard-config.json5';
import ampHoWizardConfig from '../../../../../capabilities-react/gw-capability-policychange-ho-react/config/ho-amp-wizard-config.json5';
import ampPupWizardConfig from '../../../../../capabilities-react/gw-capability-policychange-pup-react/config/pup-amp-wizard-config.json5';

import metadata from './MLNavigationStepsComponent.metadata.json5';
import styles from './MLNavigationStepsComponent.module.scss';

const isAgent = appConfig.portalCode === 'GPA';

// MLNavigationStepsDirective.js for PolicyChange progress bar
const MLNavigationStepsComponent = (props) => {
    const { currentStep, changeNextSteps, goNext, endorsementVM, steps: wizardSteps } = props;
    const isAmpMode = appConfig.portalCode === 'AMP';
    const productType = _.get(endorsementVM, 'baseData.productCode.value');
    const { additionalPolicyChangeProps } = useMLLandingPageContext();

    let wizardConfig;
    if (isAmpMode) {
        if (MLProductCodeUtil.isPersonalAuto(productType)) {
            wizardConfig = ampPaWizardConfig;
        } else if (MLProductCodeUtil.isHomeOwners(productType)) {
            wizardConfig = ampHoWizardConfig;
        } else {
            wizardConfig = ampPupWizardConfig;
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (MLProductCodeUtil.isPersonalAuto(productType)) {
            wizardConfig = paWizardConfig;
        } else if (MLProductCodeUtil.isHomeOwners(productType)) {
            wizardConfig = hoWizardConfig;
        } else {
            wizardConfig = pupWizardConfig;
        }
    }

    const { steps: wizardConfigSteps } = wizardConfig;

    const [firstSteps, setFirstSteps] = useState([]);
    const [dynamicSteps, setDynamicSteps] = useState([]);
    const [lastSteps, setLastSteps] = useState([]);

    const navData = MLNavigationStepsTrackingService.getData();
    const nameToRemove = "endorsementAddlInfoToPurchase";

    useEffect(() => {
        const updatedSteps = _.get(navData, 'lastSteps', []) || [];

        setFirstSteps(_.get(navData, 'firstSteps', []));
        setDynamicSteps(_.get(navData, 'dynamicSteps', []));

        if (additionalPolicyChangeProps.isPolicyChangeAndTrasferToPayrollFlow === true) {
            setLastSteps(updatedSteps.filter(step => step.name !== nameToRemove));
        }
        else {
            setLastSteps(_.get(navData, 'lastSteps', []));
        }
    }, [additionalPolicyChangeProps.isPolicyChangeAndTrasferToPayrollFlow, endorsementVM, navData]);

    const stuckDynamicStepsPaths = useMemo(() => {
        return wizardConfigSteps.filter((step) => step.stepProps.isStuckDynamicStep).map((step) => step.path);
    }, [wizardConfigSteps]);

    const jumpToStep = (currentNewStep) => {
        const newStepName = currentNewStep.name;
        if (currentStep.mlStepName !== 'endorsementConfirmation') {
            if (currentStep.mlStepName === 'endorsementQuoteDetails') {
                _.set(endorsementVM, 'value.stayOnStepML', true);
            }
            const currentStepIndex = _.findIndex(wizardSteps, (step) => step.id === currentStep.id);
            const newStep = _.cloneDeep(wizardSteps.find((step) => step.mlStepName === newStepName));
            if (!newStep || stuckDynamicStepsPaths.includes(currentStep.path)) return;

            if (currentNewStep) {
                if (dynamicSteps.includes(currentNewStep)) {
                    const currentNewStepIndex = dynamicSteps.indexOf(currentNewStep);

                    const dynamicStepsModifyingSameObject = dynamicSteps.filter((dynamicStep) => {
                        return (['add', 'edit', 'remove'].includes(dynamicStep.pageAction) && dynamicStep.fixedId && dynamicStep.fixedId === currentNewStep.fixedId) ||
                            (dynamicStep.pageAction === 'replace' && dynamicStep.replacedFixedId === currentNewStep.fixedId);
                    });

                    if ((currentNewStep.pageAction === 'remove' && !currentNewStep.driverType) ||
                        (dynamicStepsModifyingSameObject.some((dynamicStep) => dynamicSteps.indexOf(dynamicStep) > currentNewStepIndex))) {
                        return;
                    }
                }

                newStep.fixedId = currentNewStep.fixedId;
                newStep.pageAction = currentNewStep.pageAction;
                newStep.driverType = currentNewStep.driverType;
                newStep.replacedFixedId = currentNewStep.replacedFixedId;
                newStep.existingStep = true;
                newStep.details = currentNewStep.details;
                if(currentNewStep.additionalData){
                    newStep.additionalData = currentNewStep.additionalData
                }
            }

            const newStepIndex = _.findIndex(wizardSteps, (step) => step.id === newStep.id);
            const addtlChangesStepIndex = _.findLastIndex(wizardSteps, ({ mlStepName }) => mlStepName === 'endorsementAdditionalChanges');

            MLNavigationStepsTrackingService.stepChange(newStepName, currentStep.mlStepName);
            if (newStepIndex >= addtlChangesStepIndex) {
                const remainingSteps = wizardSteps.slice(newStepIndex, wizardSteps.length);
                changeNextSteps(remainingSteps);
                goNext();
            } else {
                MLEndorsementFlowUtil.addAndNavigateToNewStep(newStep, wizardSteps, currentStepIndex, changeNextSteps, goNext);
            }
        }
    };

    const generateAgentStepssOverrides = () => {
        const activeClassNames = "active ml-leftrail-nav__expanded-menu-item";
        const nonActiveClassNames = "ml-leftrail-nav__expanded-menu-item";
        const menuSubItemDetailsClass = "ml-leftrail-nav__expanded-menu-item-subitem"

        const firstStepsOverrides = firstSteps.map((step, index) => {
            return {
                [`agentFirstStep${index}`]: {
                    className: step.isInProgress && !step.isCompleted ? activeClassNames : nonActiveClassNames,
                    content: (
                        <>
                            <span className={(step.isInProgress || !step.isCompleted) ? "icon-ml-status-check-active" : "icon-ml-status-check-complete"} />
                            {step.displayName}
                            {!!step.details && (<p className={classNames(styles.menuSubItem, menuSubItemDetailsClass)}>{step.details}</p>)}
                        </>
                    ),
                    onClick: () => jumpToStep(step)
                }
            };
        });

        const dynamicStepsOverrides = dynamicSteps.map((step, index) => {
            return {
                [`agentDynamicStep${index}`]: {
                    className: step.isInProgress && !step.isCompleted ? activeClassNames : nonActiveClassNames,
                    content: (
                        <>
                            <span className={(step.isInProgress || !step.isCompleted) ? "icon-ml-status-check-active" : "icon-ml-status-check-complete"} />
                            {step.displayName}
                            {step.details && <p className={classNames(styles.menuSubItem, menuSubItemDetailsClass)}>{step.details}</p>}
                        </>
                    ),
                    onClick: () => jumpToStep(step)
                }
            };
        });

        const lastStepsOverrides = lastSteps.map((step, index) => {
            return {
                [`agentLastStep${index}`]: {
                    className: step.isInProgress && !step.isCompleted ? activeClassNames : nonActiveClassNames,
                    content: (
                        <>
                            <span className={(step.isInProgress || !step.isCompleted) ? "icon-ml-status-check-active" : "icon-ml-status-check-complete"} />
                            {step.displayName}
                            {step.details && <p className={classNames(styles.menuSubItem, menuSubItemDetailsClass)}>{step.details}</p>}
                        </>
                    ),
                    onClick: () => jumpToStep(step)
                }
            };
        });

        return Object.assign({}, ...firstStepsOverrides, ...dynamicStepsOverrides, ...lastStepsOverrides);
    };

    const generateNonAgentOverrides = () => {
        const firstStepsOverrides = firstSteps.map((step, index) => {
            return {
                [`nonAgentFirstStep${index}`]: {
                    className: step.isInProgress || !step.isCompleted ? "pending-icon" : "",
                    content: (
                        <>
                            <p className="body-copy display-inline-block font-weight-bold">{step.displayName}</p>
                            {step.details && <p className="body-copy light margin-left-30">{step.details}</p>}
                        </>
                    ),
                    onClick: () => jumpToStep(step)
                }
            };
        });

        const dynamicStepsOverrides = dynamicSteps.map((step, index) => {
            return {
                [`nonAgentDynamicStep${index}`]: {
                    className: step.isInProgress || !step.isCompleted ? "pending-icon" : "",
                    content: (
                        <>
                            <p className="body-copy display-inline-block font-weight-bold">{step.displayName}</p>
                            {step.details && <p className="body-copy light margin-left-30">{step.details}</p>}
                        </>
                    ),
                    onClick: () => jumpToStep(step)
                }
            };
        });

        const lastStepsOverrides = lastSteps.map((step, index) => {
            return {
                [`nonAgentLastStep${index}`]: {
                    className: step.isInProgress || !step.isCompleted ? "pending-icon" : "",
                    content: (
                        <>
                            <p className="body-copy display-inline-block font-weight-bold">{step.displayName}</p>
                            {step.details && <p className="body-copy light margin-left-30">{step.details}</p>}
                        </>
                    ),
                    onClick: () => jumpToStep(step)
                }
            };
        });

        return Object.assign({}, ...firstStepsOverrides, ...dynamicStepsOverrides, ...lastStepsOverrides);
    };

    const overrides = {
        agentNavigationSteps: {
            visible: isAgent
        },
        agentNavigationFirstSteps: {
            data: firstSteps
        },
        agentNavigationDynamicSteps: {
            data: dynamicSteps,
            visible: !!dynamicSteps
        },
        agentNavigationLastSteps: {
            data: lastSteps
        },
        nonAgentNavigationSteps: {
            visible: !isAgent
        },
        nonAgentNavigationFirstSteps: {
            data: firstSteps
        },
        nonAgentNavigationDynamicSteps: {
            data: dynamicSteps,
            visible: !!dynamicSteps
        },
        nonAgentNavigationLastSteps: {
            data: lastSteps
        },
        ...generateAgentStepssOverrides(),
        ...generateNonAgentOverrides()
    }

    const resolvers = {
        resolveClassNameMap: styles
    }

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLNavigationStepsComponent.propTypes = {

};

export default MLNavigationStepsComponent;